<template>
  <v-row class="top-progress">
      <v-col lg="4">
        <div class="green">
          <div>{{ rating }}<span
              class="text-caption">/100</span></div>
          <p>
            Уровень исполнения требований стандарта, балл
          </p>
        </div>
      </v-col>
      <v-col lg="4">
        <div class="blue">
          <div>{{ regionRating }}<span
              class="text-caption">/100</span></div>
          <p>
            Уровень заполнения сведений по региону, %
          </p>
        </div>
      </v-col>
      <v-col lg="4">
        <div class="yellow">
          <div>{{ regionVerification }}<span class="text-caption">/100</span></div>
          <p>
            Уровень верификации РОИВ сведений, %
          </p>
        </div>
      </v-col>
    </v-row>
</template>

<script >
import { getRegionIndicatorsByIndicatorIdAndPeriod } from '@/modules/api.indicators';

export default {
  name: 'DashboardRating',
  props: {
    regionCode: {
      type: String,
    },
    periodCode: {
      type: String,
    },
  },
  data: () => ({
        indicatorIdRating: 'da3e9e58-3df5-4b55-943f-835a13ac2e02',
        indicatorIdRegion: 'b88d455c-d27f-49f6-b202-6fcc65026b22',
        indicatorIdVerification: '6d8fd221-78d1-4fc8-999d-9a3651b7aab3',
        rating: 0,
        regionRating: 0,
        regionVerification: 0,
    }),
  methods: {
    async getRating() {
      const [rating, regionRating, regionVerification] = await Promise.all([
        getRegionIndicatorsByIndicatorIdAndPeriod({
          domain: 'org_monitor_rating',
          regionCode: this.regionCode,
          indicatorId: this.indicatorIdRating,
          period: this.periodCode,
        }),
        getRegionIndicatorsByIndicatorIdAndPeriod({
          domain: 'org_monitor',
          regionCode: this.regionCode,
          indicatorId: this.indicatorIdRegion,
          period: this.periodCode,
        }),
        getRegionIndicatorsByIndicatorIdAndPeriod({
          domain: 'org_monitor',
          regionCode: this.regionCode,
          indicatorId: this.indicatorIdVerification,
          period: this.periodCode,
        }),
      ]);
      if (rating.ok && regionRating.ok && regionVerification.ok) {
        const [r, regionR, regionV] = [rating.payload[0]?.value ?? 0, regionRating.payload[0]?.value ?? 0, regionVerification.payload[0]?.value ?? 0];
        this.rating = (parseFloat(r)*100).toFixed(2) ?? 0;
        this.regionRating = (parseFloat(regionR)).toFixed(2) ?? 0;
        this.regionVerification = (parseFloat(regionV)).toFixed(2) ?? 0;
      }
    }
  },
  watch: {
    periodCode: {
      handler() {
        this.getRating();
      },
      immediate: true,
    },
    regionCode: {
      handler() {
        this.getRating();
      },
      immediate: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.top-progress {
  margin-bottom: 30px;
  display: flex;
  align-items: center;

  > div > div {
    display: flex;
    flex-direction: column;
    height: 280px;
    border-radius: 20px;
    padding: 30px;

    div {
      font-weight: 600;
      font-size: 64px;
      line-height: 100%;
    }

    p {
      margin-top: auto;
      margin-bottom: 0;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 140%;
      color: #1C1C1F;

    }
  }

}
</style>